export enum StateSlice {
    AUTH = 'auth',
    BILLING = 'billing',
    CONTRACTORS = 'contractors',
    ENTITY = 'entity',
    EMPLOYEES = 'employees',
    GLOBAL = 'global',
    GO = 'go',
    INTERCOM = 'intercom',
    LOCATION = 'location',  
    PAYROLL = 'payroll',
    PREFERENCE = 'preference',
    ROUTER = 'router',
    SESSION = 'session',
    SETTINGS = 'settings',
    TAXATION = 'taxation',
    TOAST = 'toast',
    WORKPLACE = 'workplace'
};
